import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { SnackBar } from '../snackbar/snackbar.service';
import * as actions from '../actions/notification.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/effects";
import * as i2 from "../snackbar/snackbar.service";
/**
 * Notification redux effects
 *
 * @export
 * @class NotificationEffects
 */
export class NotificationEffects {
    constructor(actions$, snackbar) {
        this.actions$ = actions$;
        this.snackbar = snackbar;
        /**
         * Open notification effect used to open a snackbar using the redux store
         *
         * @type {Observable<Action>}
         * @memberof NotificationEffects
         */
        this.open$ = createEffect(() => this.actions$.pipe(ofType(actions.OPEN), map((action) => {
            this.snackbar.addSnackBar(action.payload);
            return new actions.AddNotification(action.payload);
        })));
        /**
         * Close/Dismiss notification effect used to close a snackbar which is currently opened.
         *
         * @type {Observable<Action>}
         * @memberof NotificationEffects
         */
        this.dismiss$ = createEffect(() => this.actions$.pipe(ofType(actions.DISMISS), map(() => {
            this.snackbar.dismiss();
            return new actions.Dismissing();
        })));
    }
    static { this.ɵfac = function NotificationEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationEffects)(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.SnackBar)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificationEffects, factory: NotificationEffects.ɵfac }); }
}
//# sourceMappingURL=notification.effects.js.map